/**
 * BOM Module Constants
 * Solar Industry categories and makes - extendable for future expansion
 */

// BOM Category options (Solar Industry) - extend by adding to this array
export const BOM_CATEGORY_OPTIONS = [
  "DCR",
  "Non DCR",
  "SINGLE PHASE",
  "THREE PHASE",

].map((label) => ({ value: label, label }));
// "Solar Module",
//   "Inverter",
//   "Structure",
//   "ACDB",
//   "DCDB",
//   "Earthing Kit",
//   "Lightning Arrestor",
//   "Cable",
//   "Connector",
//   "Junction Box",
//   "Monitoring System",
//   "Transformer",
//   "DCR",
//   "NON-DCR",
//   "Mounting Structure",
//   "Net Meter",
//   "BOS (Balance of System)"
// BOM Make options (Solar Industry manufacturers) - extend by adding to this array
export const BOM_MAKE_OPTIONS = [
  "Waaree",
  "Adani",
  "Vikram Solar",
  "Tata Power Solar",
  "RenewSys",
  "Goldi Solar",
  "Loom Solar",
  "Havells",
  "Polycab",
  "ABB",
  "Sungrow",
  "Growatt",
  "Delta",
  "Luminous",
  "Schneider",
  "Legrand",
].map((label) => ({ value: label, label }));
